import { JsonTreeBranchElement } from "../components/core/JsonEditorModal/JsonTreeList";

export class JsonTreeBranch {
  /**
   * Name of the list.
   */
  readonly name: string;
  readonly nameSingular?: string;
  readonly namePlural?: string;

  readonly branches: JsonTreeBranch[] = [];

  constructor(deriveFrom?: Partial<Optional<JsonTreeBranch, 'branches'>>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    if (this.branches) {
      this.branches = this.branches.map(branch => new JsonTreeBranch(branch));
    }
  }
}

/**
 * Represents a schema with 1 root and one or more branches.
 */
export class JsonTree {
  readonly root: JsonTreeBranch;

  constructor(deriveFrom?: Partial<JsonTree>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    this.root = new JsonTreeBranch(this.root);
  }
}

/**
 * Represents the structure of an object.
 */
export class JsonSchema {
  readonly tree?: JsonTree;

  constructor(deriveFrom?: Partial<JsonSchema>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    if (this.tree) {
      this.tree = new JsonTree(this.tree);
    }
  }
}

export function parseJsonElements(json: any): JsonTreeBranchElement[] {
  if (typeof json !== 'string' || !json) {
    return [];
  }

  let elements: any = null;
  try {
    elements = JSON.parse(json);
  } catch (error) {
    console.error("Error parsing JSON elements:", json);
    return [];
  }

  if (!Array.isArray(elements)) {
    console.log("JSON elements string is not an array:", json);
    return [];
  }

  return elements.filter((element: JsonTreeBranchElement) => {
    if (!element || typeof element !== 'object') {
      console.log("JSON element is not an object: Element:", element);
      return false;
    }

    if (element.elements && !Array.isArray(element.elements)) {
      console.log("JSON element `elements` is not an array. Element:", element);
      return false;
    }

    if (typeof element.value !== 'string') {
      console.log("JSON element `value` is not a string. Element:", element);
      return false;
    }

    return true;
  });
}